// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__3-QUP","phone":"Footer_phone__1LRRZ"};